import { getToDay } from '@/models/GenerateCondit/Interrelated';

const params = {
  dateRange: getToDay(),
  centerFilter: '',
  provinceArea: ''
}
export default {
  namespace: 'TemporaryRouteJournal',
  state: {
    searchParams: { ...params },
    dataList: [],
  },

  effects: {
    *getData(_, { call, put, select }) {
      const { searchParams } = yield select(({ TemporaryRouteJournal }) => TemporaryRouteJournal)
      const { centerFilter, provinceArea, dateRange } = searchParams
      // const condit = new Condit({
      //   startDate: dateRange[0],
      //   endDate: dateRange[1]
      // })
      // const gc = new GenerateCondit(condit)
      // gc.scanProvinceArea = provinceArea?.name
      // const conf = gc.converCondit()
      // console.log('conf',conf)
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}
